import createTypeDecorator from '../decorators/createTypeDecorator'
// import {
// validateMacAddress,
// validateIPorCIDR,
// validateCIDR,
// validateIP,
// validateIPv4,
// validateIPv6,
// validatePort,
// } from 'pw-validators'

export const SUBNET = Symbol("schemer.types.SUBNET")
export const IP = Symbol("schemer.types.IP")
export const IP_V4 = Symbol("schemer.types.IP_V4")
export const IP_V6 = Symbol("schemer.types.IP_V6")
export const MAC_ADDRESS = Symbol("schemer.types.MAC_ADDRESS")
export const PORT = Symbol("schemer.types.PORT")
export const DOMAIN = Symbol("schemer.types.DOMAIN")
export const URL = Symbol("schemer.types.URL")

export const subnet = createTypeDecorator(SUBNET, {
  input: {
    placeholder: "192.168.0.1/16",
    // validate: validateIPorCIDR
  },
  table: {
    width: 260
  }
})

export const ip = createTypeDecorator(IP, {
  input: {
    placeholder: "192.168.0.1",
    // validate: validateIP
  },
  table: {
    width: 220
  }
})

export const ipV4 = createTypeDecorator(IP_V4, {
  input: {
    placeholder: "192.168.0.1",
    // validate: validateIPv4
  },
  table: {
    width: 220
  }
})

export const ipV6 = createTypeDecorator(IP_V6, {
  input: {
    placeholder: "2001:0db8:85a3::",
    // validate: validateIPv6
  },
  table: {
    width: 280
  }
})

export const macAddress = createTypeDecorator(MAC_ADDRESS, {
  input: {
    placeholder: "01:23:45:67:89:ab",
    // validate: validateIP
  },
  table: {
    width: 180
  }
})

export const port = createTypeDecorator(PORT, {
  input: {
    placeholder: "3000",
    // validate: validatePort
  },
  table: {
    width: 80
  }
})

export const domain = createTypeDecorator(DOMAIN, {
  input: {
    placeholder: "example.com",
    // validate: validateDomain
  },
  table: {
    width: 140
  }
})

export const url = createTypeDecorator(URL, {
  input: {
    placeholder: "example.com/sample/1/route",
    // validate: validateURL
  },
  table: {
    width: 180
  }
})